module.exports = __webpack_public_path__ + "static/media/aces_e2_on.82bd17a5.svg";